module.exports = __webpack_public_path__ + "img/image-uni.729f6039.png";